<template>
<div>
  <div class="container">
    <form action="" class="form-horizontal">
      <div class="form-group label">
        <h4>Crear Marca</h4><br>
        <vs-input label="Nombre" type="text" class="inputx" v-model="brandPost.name" /><br>
        <vs-button class="bx bxs-paint-roll ml-3" @click="postCreate()" color="darkgreen" type="border" icon="add">Crear</vs-button>
      </div>
    </form>
  </div>
  <br><br>
  <vs-alert class="ps_alert" color="danger" v-if="show">
        {{msg}}
  </vs-alert>
  <vs-alert class="ps_alert" color="success" v-if="show1">
        {{msg}}
  </vs-alert>
</div>
</template>
<script>
import axios from 'axios'
export default {
    name: "brandrAdd",
    props:{
    },
    components: {
},
    data:()=>({
    msg: '',
    show: false,
    show1: false,
    brandPost: {
        "name" : "",
    },
    error_msg: ''
  }),
  methods: {
    scrollInto(elementId) {
      const section = document.querySelector(`#${elementId}`);
      section.scrollIntoView({
        behavior: 'smooth'
      });
    },
    postCreate(){
      const url_api = this.$store.state.url_api
      axios.post(url_api + 'api/create/brand', this.brandPost).then(response => {
        console.log(response)
        if (response.data == 'isOk'){
          this.show = false
          this.show1 = true
          this.msg = 'successfully created'
        }
        else{
          this.show = true
          this.show1 = false
          this.msg = response.data
        }
      })
      .catch((error) => {
        this.show = true
        this.show1 = false
        this.msg = error.response.data
      })
    },
  },
  mounted(){
  }
}
</script>
<style>
.ps_alert{
  margin-top: 1em;
}
  .label{
    text-align: left;
  }
.vs-select--label{
  color: #000000B3;
}
.vs-select--item{
  color: darkgreen;
}

element.style {
    font-weight: bold;
}
.vs-select-primary .vs-select--item.activex {
    background: rgb(23, 83, 65);
    color: white;
}
</style>